import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import NameTypeBadge from './NameTypeBadge'

const ContributorNameDropdownEditor = ({ options, rowData, rowIndex, editorCallback, contributorNames, validationErrors }) => {
    // Get contributor names for this specific row's author key
    // Fallback to row's own availableContributorNames for new rows from contact search
    const authorKey = rowData.authorKey
    const namesForAuthorKey = contributorNames[authorKey] || rowData.availableContributorNames || []

    // Custom item template with name type badge
    const itemTemplate = (option) => {
        if (!option) return null

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <NameTypeBadge nameType={option.nameType} nameTypeId={option.nameTypeId} />
                <span>{option.name}</span>
            </div>
        )
    }

    const handleChange = (e) => {
        const selectedOption = e.value
        if (selectedOption) {
            // Update all fields directly on rowData (passed by reference)
            rowData.contributorName = selectedOption.name
            rowData.contactNameLineNum = selectedOption.lineNum
            rowData.contributorNameType = selectedOption.nameType
            rowData.contributorNameTypeId = selectedOption.nameTypeId

            // Also update via editorCallback for PrimeReact's internal state
            editorCallback(selectedOption.name)
        }
    }

    // Find the current option by name for the value
    const currentOption = namesForAuthorKey.find(n => n.name === rowData.contributorName) || null

    return (
        <Dropdown
            value={currentOption}
            options={namesForAuthorKey}
            onChange={handleChange}
            optionLabel="name"
            placeholder="Select Contributor Name"
            filter
            disabled={!namesForAuthorKey || namesForAuthorKey.length === 0}
            className={validationErrors[rowIndex] && validationErrors[rowIndex]['contributorName'] ? 'p-invalid' : ''}
            itemTemplate={itemTemplate}
            valueTemplate={(option) => option?.name || rowData.contributorName}
        />
    )
}

export default ContributorNameDropdownEditor
